import { render, staticRenderFns } from "./UserMenuNew.vue?vue&type=template&id=41510a56&scoped=true&"
import script from "./UserMenuNew.vue?vue&type=script&lang=js&"
export * from "./UserMenuNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41510a56",
  null
  
)

export default component.exports